export const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = url;
  });

const degreesToRadians = (degrees) => (degrees * Math.PI) / 180;

const getRotatedSize = (width, height, rotation) => {
  const rotationRad = degreesToRadians(rotation);
  return {
    width: Math.abs(Math.cos(rotationRad) * width) + Math.abs(Math.sin(rotationRad) * height),
    height: Math.abs(Math.sin(rotationRad) * width) + Math.abs(Math.cos(rotationRad) * height)
  };
};

export const getCroppedImageBlob = async (imageSrc, pixelCrop, outputSize = 512, rotation = 0) => {
  const image = await createImage(imageSrc);
  const safeRotation = rotation % 360;
  const rotationRad = degreesToRadians(safeRotation);

  const { width: rotatedWidth, height: rotatedHeight } = getRotatedSize(
    image.width,
    image.height,
    safeRotation
  );

  const previewCanvas = document.createElement('canvas');
  const previewCtx = previewCanvas.getContext('2d');

  if (!previewCtx) {
    throw new Error('No se pudo preparar el lienzo para recortar');
  }

  previewCanvas.width = rotatedWidth;
  previewCanvas.height = rotatedHeight;

  previewCtx.translate(rotatedWidth / 2, rotatedHeight / 2);
  previewCtx.rotate(rotationRad);
  previewCtx.translate(-image.width / 2, -image.height / 2);
  previewCtx.drawImage(image, 0, 0);

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('No se pudo preparar el lienzo para recortar');
  }

  canvas.width = outputSize;
  canvas.height = outputSize;

  ctx.drawImage(
    previewCanvas,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputSize,
    outputSize
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('No se pudo generar la imagen recortada'));
          return;
        }
        resolve(blob);
      },
      'image/jpeg',
      0.92
    );
  });
};
